import { Provider } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../../core/use-case";
import { AgendaRepository } from "../../repositories/agenda.repositories";

export interface UserRoleDTO {
  userRole: {
    resourceId: number;
    disciplineId: number;
    practiceId: number;
    roleDescription: string;
    userRole: number;
  };
}

export class GetUserRoleUseCase implements UseCase<string, UserRoleDTO> {
  constructor(private repo: AgendaRepository) {}

  execute(param: string): Observable<UserRoleDTO> {
    return this.repo.getUserRole(param);
  }
}

const getUserRoleUseCaseFactory = (repo: AgendaRepository) =>
  new GetUserRoleUseCase(repo);

export const getUserRoleUseCaseProvider: Provider = {
  provide: GetUserRoleUseCase,
  useFactory: getUserRoleUseCaseFactory,
  deps: [AgendaRepository],
};
